//
//
//  Conversation
//
//

import { Link, useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import Api from "../api.ts";
import { Anchor, Breadcrumbs, Flex, LoadingOverlay } from "@mantine/core";
import GenesysConversationPanel from "../components/GenesysConversationPanel.tsx";
import { GenesysConversation } from "../interfaces.ts";
import { KeycloakContext } from "../components/KeycloakProvider.tsx";

function Conversation() {
    const { keycloak } = useContext(KeycloakContext);
    const [conversation, setConversation] = useState<GenesysConversation | null>(null);

    const params = useParams();
    const conversationID = params["conversationId"];

    useEffect(() => {
        if (!conversationID) {
            return;
        }

        async function fetchConversation(id: string) {
            if (!keycloak) return;

            try {
                await keycloak.updateToken(30); // refresh si le queda menos de 30s al token
                const accessToken = keycloak.token;

                if (!accessToken) {
                    throw new Error("Token no disponible");
                }

                const response = await Api.getConversation(accessToken, id);
                setConversation(response);
            } catch (err) {
                console.error("Error cargando conversaciones:", err);
                keycloak.logout(); // o muestra un error al usuario
            }
        }

        fetchConversation(conversationID).catch(console.error);
    }, [conversationID, keycloak]);

    if (conversation == null) {
        return <LoadingOverlay visible loaderProps={{ size: "xl", variant: "oval" }} />;
    }

    const ConversationPanel = {
        "GENESYS": GenesysConversationPanel
    }[conversation.channel]!;

    return (
        <>
            <Breadcrumbs mt="xl" mb="xl">
                <Anchor component={Link} to="/conversations">Conversations</Anchor>
                <Anchor component={Link} to={`/conversations/${conversationID}`}>{conversationID}</Anchor>
            </Breadcrumbs>
            <Flex>
                <ConversationPanel conversation={conversation} />
            </Flex>
        </>
    );
}

export default Conversation;
